document.addEventListener("DOMContentLoaded", function() {
	const counters = document.querySelectorAll(".insights__number-counter");
	const sectionContainer = document.querySelector(".statistics-wrapper");

	if (!sectionContainer || counters.length === 0) {
		return;
	}

	const observerOptions = {
		root: null,
		rootMargin: '0px',
		threshold: 0.2
	};
	
	// Intersection observer to trigger counting animation when the section is in view
	const observer = new IntersectionObserver(handleIntersect, observerOptions);
	observer.observe(sectionContainer);

	function handleIntersect(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				counters.forEach(counter => {
					const countTo = counter.getAttribute("data-count");
					const number = parseNumber(countTo);
					animateCount(counter, 0, number, 3000);
				});
				observer.unobserve(sectionContainer);
			}
		});
	}

	function parseNumber(str) {
		str = str.replace(/,/g, '').toLowerCase();
		if (str.includes('k')) {
			return parseFloat(str) * 1;
		}
		return parseFloat(str);
	}

	function animateCount(element, start, end, duration) {
		let startTime = null;

		function step(currentTime) {
			if (!startTime) {
				startTime = currentTime;
			}
			
			const progress = currentTime - startTime;
			const value = Math.min(Math.round(start + ((end - start) * (progress / duration))), end);

			element.innerText = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + getSuffix(element.getAttribute("data-count"));

			if (progress < duration) {
				requestAnimationFrame(step);
			}
		}

		requestAnimationFrame(step);
	}

	function getSuffix(str) {
		const match = str.match(/[a-zA-Z+]+/g);
		return match ? match.join('') : '';
	}
});
